<template>
  <div id="contenedor-listado-licitacion-visita-obra-mobile">
    <template v-for="(participante, index) in licitacionParticipantes">
      <v-card :key="index" class="mb-3">
        <v-card-title>
          {{ participante.contratista.nombreRazonSocial }}
          <v-spacer></v-spacer>
          <v-card-text>Asistió a Visita de Obra?</v-card-text>
            <asistio-switch
            v-if="mixValidaScopesActions(2)"
            :participanteVisitaObra="participante"></asistio-switch>
        </v-card-title>
      </v-card>
    </template>
  </div>
</template>

<script>
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import AsistioSwitch from '@/components/administracion/licitaciones/visitaobra/Asistio.vue';

export default {
  name: 'ListadoLicitacionVisitaObraMobile',
  data() {
    return {};
  },
  components: {
    AsistioSwitch,
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
};
</script>

<style lang="scss">
</style>
